import React from 'react'
import { Button, ButtonProps } from '../../../components/Button'

interface StatusChangeButtonProps {
  changeStatus: () => void
}

export const StatusChangeButton: React.FunctionComponent<ButtonProps & StatusChangeButtonProps> = ({
  changeStatus,
  children,
  category,
  label,
  dataTestId,
  disabled
}) => {
  return (
    <Button dataTestId={dataTestId} category={category} size="l" label={label} onClick={changeStatus} disabled={disabled}>
      {children}
    </Button>
  )
}
